import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React, { useState } from 'react';
import '../../primitives/Box/Box.es.js';
import '../../primitives/Center/styled.es.js';
import '../../primitives/Group/Group.es.js';
import '../../primitives/Grid/Grid.es.js';
import '../../primitives/Level/Level.es.js';
import '../../primitives/Shelf/Shelf.es.js';
import '../../primitives/Portal/Portal.es.js';
import '../../primitives/Hidden/Hidden.es.js';
import '../../primitives/Media/Media.es.js';
import '../../primitives/Dialog/Dialog.es.js';
import { ConditionalWrapper } from '../../primitives/ConditionalWrapper/ConditionalWrapper.es.js';
import { VisuallyHidden } from '../../primitives/VisuallyHidden/VisuallyHidden.es.js';
import '../../primitives/TruncateByCharacters/TruncateByCharacters.es.js';
import '../../primitives/TruncateByLines/TruncateByLines.es.js';
import 'react-transition-group';
import '../../primitives/Popper/Popper.es.js';
import '../../primitives/DragHandle/DragHandle.es.js';
import '../../primitives/Pin/Pin.es.js';
import { forwardRef } from '../../system/forwardRef.es.js';
import { Tooltip } from '../Tooltip/Tooltip.es.js';
import { Styled } from './styled.es.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var Switch = forwardRef(function (_a, ref) {
  var _b = _a,
      id = _b.id,
      offLabel = _b.offLabel,
      onLabel = _b.onLabel,
      tooltipOnText = _b.tooltipOnText,
      tooltipOffText = _b.tooltipOffText,
      _b$size = _b.size,
      size = _b$size === void 0 ? "md" : _b$size,
      isOn = _b.isOn,
      isDisabled = _b.isDisabled,
      isInvalid = _b.isInvalid,
      onChange = _b.onChange,
      onFocus = _b.onFocus,
      onBlur = _b.onBlur,
      onClick = _b.onClick,
      children = _b.children,
      props = __objRest(_b, ["id", "offLabel", "onLabel", "tooltipOnText", "tooltipOffText", "size", "isOn", "isDisabled", "isInvalid", "onChange", "onFocus", "onBlur", "onClick", "children"]);

  var _useState = useState(),
      isChecked = _useState[0],
      setIsChecked = _useState[1];

  var handleOnChange = function handleOnChange(e) {
    setIsChecked(e.target.checked);
    onChange == null ? void 0 : onChange(e);
  };

  var handleClick = function handleClick(e) {
    if (isDisabled) return;
    onClick == null ? void 0 : onClick(e);
  };

  return (
    /* @__PURE__ */
    React.createElement(Styled.ComponentWrapper, __spreadValues({
      onClick: handleClick
    }, props),
    /* @__PURE__ */
    React.createElement(ConditionalWrapper, {
      condition: tooltipOnText && tooltipOffText,
      wrapper: function wrapper(children2) {
        return (
          /* @__PURE__ */
          React.createElement(Tooltip, {
            content: isChecked ? tooltipOnText : tooltipOffText,
            position: "top"
          }, children2)
        );
      }
    },
    /* @__PURE__ */
    React.createElement(VisuallyHidden, {
      as: "input",
      type: "checkbox",
      id: id,
      disabled: isDisabled,
      onChange: handleOnChange,
      onFocus: onFocus,
      onBlur: onBlur,
      checked: isOn,
      "aria-invalid": isInvalid,
      "aria-checked": isOn,
      ref: ref
    }), offLabel &&
    /* @__PURE__ */
    React.createElement(Styled.OffLabel, {
      size: size
    }, offLabel),
    /* @__PURE__ */
    React.createElement(Styled.OuterSwitch, {
      size: size,
      isDisabled: isDisabled
    },
    /* @__PURE__ */
    React.createElement(Styled.InnerSwitch, {
      size: size,
      isDisabled: isDisabled
    },
    /* @__PURE__ */
    React.createElement(Styled.Handle, {
      size: size,
      isDisabled: isDisabled
    }))), onLabel &&
    /* @__PURE__ */
    React.createElement(Styled.OnLabel, {
      size: size
    }, onLabel)))
  );
});
Switch.displayName = "Switch";
export { Switch };